<template>
  <div>
    <div class="se-flex aic jcsb">
      <div class="ft-22-333 se-m-b-30">查看详情</div>
      <div class="se-flex">
        <div
          class="se-see-info-edit cp"
          v-if="info.auditStatus === 2"
          @click="goEdit"
        >
          编辑
        </div>
        <div class="se-see-info cp" @click="goBack">返回</div>
      </div>
    </div>
    <el-form ref="form" :model="form" label-width="80px" label-position="left">
      <el-form-item label="课件名称">
        <div>{{ info.courseName }}</div>
      </el-form-item>
      <el-form-item label="课件封面">
        <div class="preview" @click="getShow(info.coverUrl)">
          <img
            :src="info.coverUrl"
            style="width: 160px; height: 140px; object-fit: cover"
          />
          <div><i class="eye el-icon-view" /></div>
        </div>
      </el-form-item>
      <el-form-item label="专业分类">
        <div>{{ info.sepcialtyName }}</div>
      </el-form-item>
      <el-form-item label="课件内容">
        <div>{{ info.courseSummary }}</div>
      </el-form-item>
      <el-form-item label="课件视频">
        <div class="se-flex aic">
          <img
            src="../../../assets/icons/video.png"
            style="width: 27px; height: 31px"
          />
          <div class="se-look se-m-l-20 cp" @click="openVideo">查看</div>
        </div>
      </el-form-item>
      <el-form-item label="课件文件">
        <div
          class="se-flex aic"
          v-for="(item, index) of trainCourseFiles"
          :key="index"
        >
          <div>{{ item.fileName }}</div>
          <div
            class="se-look se-m-l-20 cp"
            @click="openUrl(item.fileUrl, item.fileName)"
          >
            下载
          </div>
        </div>
      </el-form-item>
      <el-form-item label="考试题目">
        <div class="se-look se-m-l-20 cp" @click="getExamList">查看</div>
      </el-form-item>
      <el-form-item label="评价模板">
        <div class="se-flex aic">
          <div>{{ trainCourseEvaTmpl.templateName }}</div>
          <div class="se-look se-m-l-20 cp" @click="isShow">查看</div>
        </div>
      </el-form-item>
      <el-form-item class="se-form-item" label="审批进度">
        <el-steps :active="stepsActive">
          <el-step
            v-for="(item, index) of auditProcessVoList"
            :key="index"
            :title="item.stepType"
          >
            <template slot="icon">
              <i
                v-if="
                  item.stepType === '提交审核' ||
                  (item.hasDone && item.message === '通过') ||
                  (item.hasDone && item.message == null)
                "
                class="iconfont icon-duigouxiao"
              ></i>
              <!-- v-if="
                  !item.hasDone ||
                  (item.message !== '通过' &&
                    item.hasDone &&
                    item.stepType !== '提交审核')
                " -->
              <i
                v-else
                class="el-icon-circle-close"
                style="font-size: 16px; color: red"
              ></i>
            </template>
            <template slot="description">
              <div class="ft-12-666">
                <div>{{ item.personName }}</div>
                <div>{{ item.stepTime ? tranferTime(item.stepTime) : "" }}</div>
                <div
                  :class="[
                    item.hasDone &&
                    item.message !== '通过' &&
                    item.message !== null
                      ? 'se-bh-color'
                      : '',
                  ]"
                >
                  <!-- <span
                    v-if="
                      item.hasDone &&
                      item.message !== '通过' &&
                      item.message !== null
                    "
                    >驳回原因:</span
                  >{{ item.message }} -->
                  <el-popover
                    placement="top-start"
                    title="驳回原因"
                    width="200"
                    trigger="hover"
                    :content="item.message"
                  >
                    <a
                      v-if="
                        item.hasDone &&
                        item.message !== '通过' &&
                        item.message !== null
                      "
                      slot="reference"
                    >
                      <i
                        class="el-icon-warning-outline"
                        style="font-size: 14px; color: #1890ff"
                      ></i>
                      查看驳回原因
                    </a>
                  </el-popover>
                </div>
              </div>
            </template>
          </el-step>
        </el-steps>
      </el-form-item>
    </el-form>
    <!-- 查看视频对话框 -->
    <el-dialog
      title="查看视频"
      destroy-on-close
      :visible.sync="videoVisible"
      width="50%"
    >
      <video ref="course" :src="info.videoUrl" v-if="videoVisible" id="video" controls style="width: 100%" ></video>
			<!-- <base-video id="video" v-if="videoVisible" :autoplay="true" :videoUrl="info.videoUrl" /> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="videoVisible = false">取 消</el-button>
        <el-button type="primary" @click="videoVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 查看考试对话框 -->

    <!-- destroy-on-close -->
    <el-dialog
      class="se-dialog"
      destroy-on-close
      :visible.sync="testVisible"
      width="665px"
    >
      <start-test
        @onClose="onClose"
        :examData="examData"
        :courseId="courseId"
        justRead
      ></start-test>
    </el-dialog>
    <!-- 评价对话框 -->
    <el-dialog
      title="课程评价"
      destroy-on-close
      :visible.sync="visible"
      width="28%"
    >
      <user-evaluate
        :satrInfo="satrInfo"
        ref="evaluate"
        justRead
      ></user-evaluate>
      <!-- <span slot="footer" class="se-flex jcc">
        <el-button type="danger" style="width: 117px" @click="visible = false"
          >确 定</el-button
        >
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import startTest from "../../course-info/components/startTest.vue";
import userEvaluate from "../../course-info/components/userEvaluate.vue";
import moment from "moment";
// import BaseVideo from '@/views/components/video.vue'
import flvjs from 'flv.js'
export default {
  components: {
    startTest,
    userEvaluate,
		// BaseVideo
  },

  props: {
    courseId: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      satrInfo: {},
      examData: {},
      info: {},
      type: 1,
      form: {},
      visible: false,
      videoVisible: false,
      testVisible: false,
      stepsActive: 0,
      auditProcessVoList: [],
      trainCourseFiles: [],
      trainCourseEvaTmpl: {},
			flvPlayer: null,
    };
  },

  created() {
    if (!this.courseId) {
      this.courseId = this.$route.query.courseId;
    }
    this.getInfo();
  },

  methods: {
    openUrl(url, name) {
      const x = new XMLHttpRequest();
      x.open("GET", url, true);
      x.responseType = "blob";
      x.onload = () => {
        const newUrl = window.URL.createObjectURL(x.response);
        // console.log("newUrl", newUrl);
        this.downLoad(newUrl, name);
      };
      x.send();
    },

    downLoad(file, name) {
      const link = document.createElement("a");
      link.style.display = "none";
      link.href = file;
      // console.log(name);
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    openVideo() {
      // window.open(this.info.videoUrl, "_blank");
      this.videoVisible = true;
			  var suffix =  this.info.videoUrl.substring(this.info.videoUrl.lastIndexOf(".") + 1); //txt
				if(suffix === 'flv') {
					this.$nextTick(() => {
					const videoElement = document.getElementById('video')
					this.flvPlayer = flvjs.createPlayer({
						type: 'flv',
						isLive: false,
						url: this.info.videoUrl
					})
					this.flvPlayer.attachMediaElement(videoElement)
					this.flvPlayer.load()
				})
				}
    },

    tranferTime(date) {
      return moment(date).format("YYYY-MM-DD HH:mm");
    },

    async getInfo() {
      const res = await this.$http.get(
        `server/portal/personCenter/getMyCourseDetails/${this.courseId}`
      );
      const { auditProcessVoList, trainCourseFiles, trainCourseEvaTmpl } =
        res.data;
      this.info = res.data;
      this.trainCourseFiles = trainCourseFiles;
      this.auditProcessVoList = auditProcessVoList;
      this.trainCourseEvaTmpl = trainCourseEvaTmpl || '';
      if (auditProcessVoList.filter((s) => s.hasDone).length) {
        this.stepsActive =
          auditProcessVoList.filter((s) => s.hasDone).length - 1;
      }
    },

    goBack() {
      let data = {
        type: 1,
        auditStatusType: "",
      };
      this.$emit("goBack", data);
    },

    // 展示评价对话框
    async isShow() {
      const {
        data: { hasContent, hasStar, trainCourseEvaTmplLabels },
      } = await this.$http.get(
        `server/portal/home/getTrainCourseEvaTmpl/${this.courseId}`
      );
      this.satrInfo = {
        hasContent,
        hasStar,
        trainCourseEvaTmplLabels,
      };
      this.visible = true;
    },

    // 展示开始考试

    getExamList() {
      this.$http
        .get("server/portal/personCenter/getCourseExam/" + this.courseId)
        .then((res) => {
          this.examData = res.data;
          this.testVisible = true;
        });
    },

    // close
    onClose() {
      this.testVisible = false;
    },

    // 审批驳回的重新编辑
    goEdit() {
      let data = {
        type: 3,
        auditStatusType: "edit",
        courseId: this.courseId,
      };
      this.$emit("goBack", data);
    },

    // 查看大图
    getShow(url) {
      open(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.se-look {
  font-size: 12px;
  font-weight: 400;
  text-decoration: underline;
  color: #e44352;
}

/deep/ .se-form-item .el-form-item__content {
  line-height: 0px;
}

@font-face {
  font-family: "iconfont"; /* Project id 2911089 */
  src: url("//at.alicdn.com/t/font_2911089_nfl4tjgmtm8.woff2?t=1635906046284")
      format("woff2"),
    url("//at.alicdn.com/t/font_2911089_nfl4tjgmtm8.woff?t=1635906046284")
      format("woff"),
    url("//at.alicdn.com/t/font_2911089_nfl4tjgmtm8.ttf?t=1635906046284")
      format("truetype");
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-duigouxiao:before {
  content: "\e8bd";
  color: #38c425;
}

.icon-luyin:before {
  content: "\e600";
  color: #e3e3e3;
}

/deep/.el-step__icon.is-text {
  border: none;
}

/deep/ .el-step__title.is-finish {
  color: #666666;
}

/deep/ .el-step__head.is-finish {
  color: #c0c4cc;
  border-color: #c0c4cc;
}

.se-see-info {
  border: 1px solid #999999;
  border-radius: 5px;
  width: 110px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  background-color: #fff;
}

.se-see-info-edit {
  border: 1px solid #1890ff;
  border-radius: 5px;
  width: 110px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  background-color: #1890ff;
  margin-right: 20px;
}

.se-bh-color {
  color: #1890ff;
  cursor: pointer;
}

.preview {
  position: relative;
  width: 160px;
  height: 140px;
  &:hover {
    div {
      display: flex;
      cursor: pointer;
    }
  }
  div {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.55);
    display: none;
    align-items: center;
    justify-content: center;
    .eye {
      font-size: 30px;
      color: #ffffff;
    }
  }
}
</style>
